/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strava_UnavailableInputs */

const en_us2_strava_unavailable = /** @type {(inputs: Strava_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strava is not available right now.`)
};

const pt_br2_strava_unavailable = /** @type {(inputs: Strava_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Strava não está disponível agora.`)
};

const pt_pt2_strava_unavailable = /** @type {(inputs: Strava_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Strava não está disponível agora.`)
};

/** @type {(inputs: Strava_UnavailableInputs) => LocalizedString} */
const es_419_strava_unavailable = en_us2_strava_unavailable;

/** @type {(inputs: Strava_UnavailableInputs) => LocalizedString} */
const fr_fr2_strava_unavailable = en_us2_strava_unavailable;

/** @type {(inputs: Strava_UnavailableInputs) => LocalizedString} */
const de_de2_strava_unavailable = en_us2_strava_unavailable;

/** @type {(inputs: Strava_UnavailableInputs) => LocalizedString} */
const it_it2_strava_unavailable = en_us2_strava_unavailable;

/**
* | output |
* | --- |
* | "Strava is not available right now." |
*
* @param {Strava_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const strava_unavailable = /** @type {((inputs?: Strava_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strava_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_strava_unavailable(inputs)
	if (locale === "es-419") return es_419_strava_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_strava_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_strava_unavailable(inputs)
	if (locale === "de-DE") return de_de2_strava_unavailable(inputs)
	if (locale === "it-IT") return it_it2_strava_unavailable(inputs)
	return en_us2_strava_unavailable(inputs)
});
export { strava_unavailable as "strava.unavailable" }